import { memo } from 'react';

import { usePrivateWorkspaceAgentGuidedVariantBrandKits } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantBrandKits';
import { usePrivateWorkspaceAgentGuidedVariantImageSelection } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantImageSelection';
import { WorkspaceAgentGuidedVariantRoundedCornersSettings } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantRoundedCornersSettings';
import { type WorkspaceAgentGuidedVariantGenerateRequest } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantGenerateRequest';

export type PrivateWorkspaceAgentGuidedVariantRoundedCornersSettingsProps = {
  onGenerate: (request: WorkspaceAgentGuidedVariantGenerateRequest) => void;
};

export const PrivateWorkspaceAgentGuidedVariantRoundedCornersSettings = memo(
  ({ onGenerate }: PrivateWorkspaceAgentGuidedVariantRoundedCornersSettingsProps) => {
    const selection = usePrivateWorkspaceAgentGuidedVariantImageSelection();
    const { brandKits, isLoading } = usePrivateWorkspaceAgentGuidedVariantBrandKits();

    return (
      <WorkspaceAgentGuidedVariantRoundedCornersSettings
        brandKits={brandKits}
        isBrandKitLoading={isLoading}
        onGenerate={onGenerate}
        selection={selection}
      />
    );
  },
);

PrivateWorkspaceAgentGuidedVariantRoundedCornersSettings.displayName =
  'PrivateWorkspaceAgentGuidedVariantRoundedCornersSettings';
